import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images, externalLinks } from '../data/mock';
import { ExternalLink, Phone } from 'lucide-react';

const Hero = () => {
  const { t } = useLanguage();
  
  // Check if KakaoTalk URL exists
  const hasKakao = externalLinks.kakao && externalLinks.kakao.length > 0;

  return (
    <section 
      className="relative min-h-screen flex items-center pt-20"
      style={{
        backgroundImage: `url(${images.hero})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black" />
      
      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-20 w-full">
        <div className="max-w-2xl">
          {/* Badges */}
          <div className="flex flex-wrap gap-2 mb-6">
            <span className="px-3 py-1 bg-[#00FFD1]/20 text-[#00FFD1] text-xs font-medium">
              {t('badge1')}
            </span>
            <span className="px-3 py-1 bg-white/10 text-white/90 text-xs font-medium">
              {t('badge2')}
            </span>
            <span className="px-3 py-1 bg-white/10 text-white/90 text-xs font-medium">
              {t('badge3')}
            </span>
          </div>

          {/* Title */}
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-4 leading-tight whitespace-pre-line">
            {t('heroTitle')}
          </h1>
          <p className="text-xl md:text-2xl text-[#00FFD1] font-medium mb-6">
            {t('heroSubtitle')}
          </p>
          
          {/* Description */}
          <p className="text-white/85 text-lg md:text-xl mb-8 whitespace-pre-line leading-relaxed">
            {t('heroDesc')}
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href={externalLinks.naverStore}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#00FFD1] text-black font-semibold text-lg transition-all duration-300 hover:bg-[#00FFD1]/10 hover:text-[#00FFD1]"
              style={{ borderRadius: 0 }}
            >
              {t('naverReserve')}
              <ExternalLink size={18} />
            </a>
            {hasKakao ? (
              <a
                href={externalLinks.kakao}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 text-white font-semibold text-lg transition-all duration-300 hover:bg-white hover:text-black"
                style={{ borderRadius: 0 }}
              >
                {t('kakaoInquiry')}
                <ExternalLink size={18} />
              </a>
            ) : (
              <a
                href={externalLinks.phone}
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white/10 text-white font-semibold text-lg transition-all duration-300 hover:bg-white hover:text-black"
                style={{ borderRadius: 0 }}
              >
                <Phone size={18} />
                010-5446-8087
              </a>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;